import { StyledSlider } from './Slider.styles';
import { SliderSingleProps, SliderRangeProps } from './Slider.interface';

export const Slider: React.FC<SliderSingleProps | SliderRangeProps> = props => (
  <StyledSlider {...props} />
);
